import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  IonAvatar,
  IonButton,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonMenu,
  IonSegment,
  IonText,
  IonRadio,
  IonAccordionGroup,
} from '@ionic/angular/standalone';
import { FormElementsModule } from '../form-elements/form-elements.module';
import { IonicModule } from '@ionic/angular';
@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    IonSegment,
    IonList,
    IonIcon,
    IonItem,
    IonText,
    IonLabel,
    IonAvatar,
    IonButton,
    IonMenu,
    IonRadio,
    IonAccordionGroup,
    FormElementsModule,
  ],
  exports: [
    CommonModule,
    IonSegment,
    IonList,
    IonIcon,
    IonItem,
    IonAvatar,
    IonButton,
    IonMenu,
    IonText,
    IonLabel,
    IonRadio,
    IonAccordionGroup,
  ],
  providers: [],
})
export class CustomIonModule {}
